if(!customElements.get('veronni-cart-drawer')){
  customElements.define('veronni-cart-drawer',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.controller=new AbortController();
      this.dialog=this.querySelector('dialog');
      this.queue=Promise.resolve();
      this.pending=0;
      this.busy=false;
      this.closeVersion=0;
      const options={signal:this.controller.signal};
      document.addEventListener('click',event=>{
        const opener=event.target.closest('[data-cart-open]');
        if(!opener||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();
        if(this.dialog.open)return;
        this.open(opener);
        this.refresh().catch(error=>this.showError(error));
      },options);
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-cart-close]')||event.target===this.dialog){this.close();return;}
        if(event.target.closest('[data-cart-retry]')){this.refresh().catch(error=>this.showError(error));return;}
        const button=event.target.closest('[data-cart-delta],[data-cart-remove]');
        if(!button||this.busy||this.needsRefresh)return;
        const line=button.closest('[data-cart-line]');
        if(!line)return;
        const quantity=button.hasAttribute('data-cart-remove')?0:Number(line.dataset.lineQuantity)+Number(button.dataset.cartDelta);
        this.change(line.dataset.cartLine,Math.max(0,quantity),button);
      },options);
      this.addEventListener('change',event=>{
        const input=event.target.closest('[data-cart-quantity]');
        if(!input||this.busy||this.needsRefresh)return;
        const line=input.closest('[data-cart-line]');
        const quantity=Number(input.value);
        if(!Number.isInteger(quantity)||quantity<0){input.value=line.dataset.lineQuantity;return;}
        this.change(line.dataset.cartLine,quantity,input);
      },options);
      this.dialog.addEventListener('close',()=>{
        this.closeVersion++;
        document.documentElement.classList.remove('vc-cart-open');
        document.querySelectorAll('[data-cart-open]').forEach(el=>el.setAttribute('aria-expanded','false'));
        if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});
      },options);
      this.syncCount(this.querySelector('[data-cart-content]'));
    }
    disconnectedCallback(){this.controller?.abort();document.documentElement.classList.remove('vc-cart-open');this.ready=false;}
    sectionIds(){const ids=[this.dataset.sectionId];const page=document.querySelector('[data-cart-page]');if(page?.dataset.sectionId)ids.push(page.dataset.sectionId);return ids;}
    sectionContext(){return window.location.pathname+window.location.search;}
    open(opener){
      if(this.dialog.open)return;
      if(typeof this.dialog.showModal!=='function'){window.location.assign(this.dataset.cartUrl);return;}
      this.returnFocus=opener||document.activeElement;
      this.dialog.showModal();
      document.documentElement.classList.add('vc-cart-open');
      document.querySelectorAll('[data-cart-open]').forEach(el=>el.setAttribute('aria-expanded','true'));
      this.querySelector('[data-cart-close]')?.focus({preventScroll:true});
    }
    close(){if(this.dialog.open)this.dialog.close();}
    syncCount(content){
      const count=Number(content?.dataset.itemCount)||0;
      document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=String(count);if(el.closest('[data-cart-open]'))el.hidden=count===0;});
    }
    clearError(){
      const error=this.querySelector('[data-cart-error]');
      error.hidden=true;error.textContent='';
      this.querySelector('[data-cart-recovery]').hidden=true;
    }
    showError(failure){
      const error=this.querySelector('[data-cart-error]');
      error.textContent=failure?.cartMessage||this.dataset.errorText;
      error.hidden=false;
      this.querySelector('[data-cart-recovery]').hidden=false;
    }
    cartError(description){
      const error=new Error(this.dataset.errorText);
      // Only show short, plain Shopify messages, never response HTML or parser errors.
      error.cartMessage=typeof description==='string'&&description.length<=180&&!/[<>{}\n\r]|SyntaxError|Unexpected token|stack trace/i.test(description)?description:this.dataset.errorText;
      return error;
    }
    async request(url,options={}){
      let response,result;
      try{
        response=await fetch(url,{...options,headers:{Accept:'application/json',...options.headers}});
        result=await response.json();
      }catch{throw this.cartError();}
      if(!response.ok)throw this.cartError(result?.description);
      return result;
    }
    enqueue(task){
      this.pending++;
      this.clearError();
      this.setBusy(true);
      const operation=this.queue.then(task);
      const settled=operation.finally(()=>{this.pending--;this.setBusy(this.pending>0);});
      // Reads and writes share one queue; failures must not block the next request.
      this.queue=settled.catch(()=>{});
      return settled;
    }
    refresh(){
      if(this.refreshPromise)return this.refreshPromise;
      const request=this.enqueue(()=>this.loadSections());
      this.refreshPromise=request;
      request.then(()=>{this.refreshPromise=null;},()=>{this.refreshPromise=null;});
      return request;
    }
    async loadSections(){
      const url=new URL(window.location.href);
      url.searchParams.set('sections',this.sectionIds().join(','));
      try{
        const sections=await this.request(url.pathname+url.search,{cache:'no-store'});
        await this.updateFromSections(sections,false);
      }catch(error){this.needsRefresh=true;throw error;}
    }
    async updateFromSections(sections,retry=true){
      const html=sections?.[this.dataset.sectionId];
      const parsed=typeof html==='string'?new DOMParser().parseFromString(html,'text/html'):null;
      const content=parsed?.querySelector('veronni-cart-drawer [data-cart-content]');
      if(!content){if(retry)return this.loadSections();throw this.cartError();}
      this.querySelector('[data-cart-content]').replaceWith(content);
      const page=document.querySelector('[data-cart-page]');
      if(page&&sections?.[page.dataset.sectionId]){
        const pageHtml=new DOMParser().parseFromString(sections[page.dataset.sectionId],'text/html');
        const pageContent=pageHtml.querySelector('[data-cart-page-content]');
        if(pageContent)page.querySelector('[data-cart-page-content]').replaceWith(pageContent);
      }
      this.needsRefresh=false;
      this.setBusy(this.busy);
      this.syncCount(content);
      this.querySelector('[data-cart-status]').textContent=this.dataset.updatedText+' '+content.dataset.cartSubtotal;
      this.clearError();
      document.dispatchEvent(new CustomEvent('veronni:cart-updated',{detail:{itemCount:Number(content.dataset.itemCount)}}));
    }
    setBusy(value){
      this.busy=value;
      const content=this.querySelector('[data-cart-content]');
      const blocked=value||this.needsRefresh;
      content.setAttribute('aria-busy',String(value));
      content.querySelectorAll('button,input').forEach(el=>el.disabled=Boolean(blocked));
      const checkout=content.querySelector('[data-cart-checkout]');
      if(checkout){if(blocked){checkout.setAttribute('aria-disabled','true');checkout.setAttribute('inert','');}else{checkout.removeAttribute('aria-disabled');checkout.removeAttribute('inert');}}
      this.querySelector('[data-cart-loading]').hidden=!value;
      this.querySelector('[data-cart-retry]').disabled=value;
    }
    addItems(items,opener){
      const closeVersion=this.closeVersion;
      return this.enqueue(async()=>{
        let result;
        try{
          result=await this.request(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:this.sectionIds(),sections_url:this.sectionContext()})});
        }catch(error){
          // Reconcile an uncertain response without repeating the add request.
          try{await this.loadSections();}catch{}
          throw error;
        }
        try{
          await this.updateFromSections(result.sections);
          if(this.closeVersion===closeVersion)this.open(opener);
        }catch{window.location.assign(this.dataset.cartUrl);}
      });
    }
    async change(key,quantity,trigger){
      if(this.busy||this.needsRefresh)return;
      const line=trigger?.closest('[data-cart-line]');
      const lineIndex=Array.from(this.querySelectorAll('[data-cart-line]')).indexOf(line);
      let updated=false;
      await this.enqueue(async()=>{
        try{
          const result=await this.request(this.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,sections:this.sectionIds(),sections_url:this.sectionContext()})});
          await this.updateFromSections(result.sections);
          updated=true;
        }catch(error){
          try{await this.loadSections();}catch{this.needsRefresh=true;}
          const input=line?.querySelector('[data-cart-quantity]');
          if(input?.isConnected)input.value=line.dataset.lineQuantity;
          this.showError(error);
        }
      });
      if(updated&&this.dialog.open){
        const lines=this.querySelectorAll('[data-cart-line]');
        const next=lines[Math.min(Math.max(0,lineIndex),lines.length-1)];
        (next?.querySelector('[data-cart-quantity]')||this.querySelector('[data-cart-close]'))?.focus({preventScroll:true});
      }
    }
  });
}
